export class PromotionCode {
}
